// アンカーリンクスクロール
const smoothAnkerScroll = (hash) => {
  const targetElement = document.querySelector(hash);
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const headerHeight = document.querySelector(
    "#shopify-section-header"
  ).clientHeight;
  const target = rect + offset - headerHeight - 10;
  window.scrollTo({
    top: target,
    behavior: "smooth",
  });
};

// NEWSブログ以外の場合、目次を生成する
document.addEventListener("DOMContentLoaded", function () {
  const articleFirstH2 = document.querySelector("#Article-Body h2");
  const articleTitleList = document.querySelectorAll(
    "#Article-Body h2,#Article-Body h3"
  );
  let tableOfContents = "";
  let h2Count = 0;
  if (articleFirstH2) {
    articleTitleList.forEach((articleTitle, index) => {
      if (
        articleTitle.textContent?.trim() !== "" &&
        articleTitle.textContent?.trim() !== "目次"
      ) {
        let titleEscaped = encodeURIComponent(articleTitle.textContent.trim());
        let h2TitleIndex = "";
        let className = "linkTo--h3";
        if (articleTitle.tagName === "H2") {
          className = "linkTo--h2";
          h2Count++;
          h2TitleIndex = `${h2Count}. `;
        }
        articleTitle.id = `title--${index}`;
        tableOfContents += `<li class="${className}">
          <a href="javascript:void(0);" onclick="smoothAnkerScroll('#title--${index}')">
          ${h2TitleIndex}
          ${articleTitle.textContent.trim()}
          </a>
        </li>`;
      }
    });

    articleFirstH2.insertAdjacentHTML(
      "beforebegin",
      `
      <div class="c-table-of-contents__wrapper">
        <strong class="c-table-of-contents__title">[目次]</strong>
        <ul class="c-table-of-contents">${tableOfContents}</ul>
      </div>
    `
    );
  }
});
